/**
 * @generated SignedSource<<dc30ab9ed3cdd374f8cdecf6294a6be5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productListDeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  productID: string;
};
export type productListDeleteMutation$data = {
  readonly deleteProduct: {
    readonly id: string;
  } | null;
};
export type productListDeleteMutation = {
  response: productListDeleteMutation$data;
  variables: productListDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "productID",
    "variableName": "productID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productListDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "deleteProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productListDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "deleteProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cd7a227c19754f38360e566449edf6c9",
    "id": null,
    "metadata": {},
    "name": "productListDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation productListDeleteMutation(\n  $productID: String!\n) {\n  deleteProduct(productID: $productID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9ff6ba1ebf1e75f9ea630c14fc00eea";

export default node;
